import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaUser, FaLock, FaMusic, FaGuitar } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import ForgotPassword from "./ForgotPassword";
import "./Auth.css";
import { login } from "./helper/auth.helper";

import { useAuth } from "../../contexts/AuthContext";

const Login = ({ onLogin }) => {
  const { login: contextLogin } = useAuth();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const response = await login({
        email: formData.email,
        password: formData.password,
      });

      if (onLogin) {
        onLogin(response.data.user);
      }
      if (contextLogin) {
        contextLogin(response.data.user);
      }
      navigate("/app");
    } catch (err) {
      console.error("Login error:", err);
      // Show user-friendly error for Firebase auth errors
      if (err?.message && err.message.includes("auth/")) {
        setError("Invalid email or password. Please check your credentials.");
      } else {
        setError(
          err?.message || "Invalid email or password. Please try again."
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <motion.div
      className="auth-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="auth-background">
        <div className="music-note note-1">
          <FaMusic />
        </div>
        <div className="music-note note-2">
          <FaGuitar />
        </div>
        <div className="music-note note-3">
          <FaMusic />
        </div>
      </div>

      {showForgotPassword ? (
        <ForgotPassword onBackToLogin={() => setShowForgotPassword(false)} />
      ) : (
        <motion.div
          className="auth-card"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          <div className="auth-header">
            <motion.h2
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              transition={{
                type: "spring",
                stiffness: 260,
                damping: 20,
              }}
            >
              Welcome Back
            </motion.h2>
            <p>Sign in to continue your musical journey</p>
          </div>

          {error && (
            <motion.div
              className="auth-error"
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
            >
              {error}
            </motion.div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <FaUser className="input-icon" />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <FaLock className="input-icon" />
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-options">
              {/* <label className="remember-me">
                <input type="checkbox" /> Remember me
              </label> */}
              {/* <button
                type="button"
                className="forgot-password link-button"
                onClick={() => setShowForgotPassword(true)}
                style={{ background: "none", border: "none", color: "#3498db", cursor: "pointer", padding: 0 }}
              >
                Forgot Password?
              </button> */}
            </div>

            <motion.button
              type="submit"
              className="auth-button"
              disabled={isLoading}
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
            >
              {isLoading ? "Signing in..." : "Sign In"}
            </motion.button>
          </form>

          <div className="auth-footer">
            <p>
              Don't have an account? <Link to="/signup">Sign Up</Link>
            </p>
          </div>
        </motion.div>
      )}
    </motion.div>
  );
};

export default Login;
